import React, { useEffect } from "react";
import _ from "lodash";
import clsx from "clsx";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { isMobileOnly, isTablet, getUA } from "react-device-detect";
import URL from "../../constant/URL";
import TYPE from "../../constant/TYPE";
import PROP from "../../constant/PROP";
import { setDeviceInfoAction, clearDeviceInfoAction } from "../../redux/deviceInfo";

let history;

const WrapInnerRenderer = ( props ) => {

  const location = useLocation();

  const deviceInfo = useSelector( state => state.deviceInfo );
  const userInfo = useSelector( state => state.user.info );

  const dispatch = useDispatch();
  const setDeviceInfo = payload => { dispatch( setDeviceInfoAction( payload ) ) };
  const clearDeviceInfo = () => { dispatch( clearDeviceInfoAction() ) };

  history = useHistory();

  useEffect( () => {
    switch ( true ) {
      case isTablet :
      case !! PROP.DEFINITELY_PAD.filter( v => -1 < getUA.indexOf( v ) ).length :
        setDeviceInfo( { type : TYPE.DEVICE.PAD } );
        break;
      case isMobileOnly :
        setDeviceInfo( { type : TYPE.DEVICE.PHONE } );
        break;
    }
    return () => {
      clearDeviceInfo();
    };
  }, [] );

  const getClassName = () => {
    let productType = '';
    switch ( true ) {
      case TYPE.CHANNEL.WJTB === userInfo?.channelCode :
      case TYPE.ENTRY_TYPE.GM === userInfo?.entryType :
        productType =  userInfo?.entryType === TYPE.ENTRY_TYPE.GM_APP ? 'v-app' : '';
        break;
    }
    return clsx( 'wrap-inner', deviceInfo.type, productType );
  };

  switch ( true ) {
    case _.includes( URL.IFRAME, location.pathname ) :
      return props.children || null;
    default :
      return <div id="app_main" className={ getClassName() }>{ props.children }</div>;
  }

};

export default WrapInnerRenderer;
export { history };
